export default __webpack_public_path__ + "static/media/Comp 2_00012.97319cc6.png";